<template>
    <div>
        <div style="width: 80%;float: right">
        <span style ="color: #ff5435;">温馨提示：</span>1. 绿色表格代表未预约，可点击占位; 2. -- 代表未排班，不可预约; 3. 有患者姓名的代表已预约,可点击查看预约人信息
        </div>
        <el-row style="margin: 10px 6.5%">
            <el-button type="primary" @click="dialogVis = true">加诊</el-button>
        </el-row>
        <el-dialog title="请填写信息" :visible.sync="dialogVis" width="600px" :before-close="handleClose">
            <div class="yuyuem">
                <h3 style="margin-top: 15px"> 类&nbsp;&nbsp;&nbsp;型：
                    <el-select v-model="emergency" filterable placeholder="请选择" @change="changeEmeValue">
                        <el-option
                                v-for="item in emergencyList"
                                :key="item.index"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </h3>
                <h3 style="margin-top: 15px;">日&nbsp;&nbsp;&nbsp;期：
                    <el-date-picker
                            v-model="Jdate"
                            type="date"
                            :picker-options="pickerOptions0"
                            placeholder="选择日期">
                    </el-date-picker>
                </h3>
                <h3 style="margin-top: 15px;">时&nbsp;&nbsp;&nbsp;间：
                    <el-time-select
                            placeholder="起始时间"
                            v-model="startTime"
                            :picker-options="{
                          start: '16:00',
                      step: '00:10',
                      end: '22:00',
                        }">
                    </el-time-select>
                    <el-time-select
                            placeholder="结束时间"
                            v-model="endTime"
                            :picker-options="{
                      start: '16:00',
                      step: '00:10',
                      end: '22:00',
                      minTime: startTime
                    }">
                    </el-time-select>
                </h3>
                <h3 style="margin-top: 15px"> 姓&nbsp;&nbsp;&nbsp;名：
                    <el-select v-model="Jname" filterable placeholder="请选择" @change="changeValue">
                        <el-option
                                v-for="item in options"
                                :key="item.index"
                                :label="item.name+ ' '+item.mobileNumber"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </h3>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVis = false">取 消</el-button>
                 <el-button type="primary" @click="sure()">确 定</el-button>
            </span>
        </el-dialog>
        <div class="app_first">

            <div class="doctor_menu">
                <template>
                    <el-tabs :tab-position="tabPosition">
                        <el-tab-pane v-for="(item, index) in doctor" :label="item.name" :key="index"
                                     style="width: 100%"></el-tab-pane>
                    </el-tabs>
                </template>
            </div>

            <div class="right">
                <!--表单-->

                <table border="1" cellspacing="0">

                    <tr style="background-color: #f2f2f2;color: #a4a7af;">
                        <td>预约</td>
                        <td v-for="(item,index) in items" :key="index">
                            <!-- {{ weeks[index].item.week_value }} -->
                            <!-- 周几 -->
                            <!--
                            <span v-if="(which_weekDay+index)<7">{{ dayNames[which_weekDay+index]}}</span>
                            <span v-else>{{ dayNames[which_weekDay+index-7]}}</span>
                             -->
                            <span>{{ dayNames[(which_weekDay+index)%7]}}</span>
                            <br>
                            <span>{{ dateArr[index]}}</span>
                            <!-- 日期几月几号 -->

                        </td>
                    </tr>
                    <tr class="td_65px" v-for="(item,index) in reserDetail" :key="index"
                        :class="{backgroundColor:active}">

                        <td v-for="(items,index_a) in item" :key="index_a" style="cursor:pointer;"
                            @click="tdclick(items,index_a)">
                            <div v-if="index_a!==0 && items.split(',')[0] === '**..'" style="background:darkseagreen">可预约 </div>
                            <div v-else>{{index_a!==0 ? items.split(",")[0]: items}} </div>
                        </td>
                    </tr>
                </table>

            </div>


            <el-dialog title="预约人信息" :visible.sync="dialogVisible" width="30%">
                <div class="yuyuem">
                    <h3>姓&nbsp;&nbsp;&nbsp;名：{{name}}</h3>
                    <h3>性&nbsp;&nbsp;&nbsp;别：{{gender}}</h3>
                    <h3>年&nbsp;&nbsp;&nbsp;龄：{{age}}</h3>
                    <h3>手机号：{{phone}}</h3>
                </div>
                <span slot="footer" class="dialog-footer">
                <el-button @click="subscribe(reservationId)">取 消 预 约</el-button>
                    <!--<el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
            </span>
            </el-dialog>
            <el-dialog title="选择患者" :visible.sync="seizeVisible" width="30%">
                <div class="yuyuem">
                    <h3 style="margin-top: 15px"> 姓&nbsp;&nbsp;&nbsp;名：
                        <el-select v-model="Jname" filterable placeholder="请选择" @change="changeValue">
                            <el-option
                                    v-for="item in options"
                                    :key="item.index"
                                    :label="item.name+ ' '+item.mobileNumber"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </h3>
                </div>
                <span slot="footer" class="dialog-footer">
                <el-button @click="seize(reservationId)">确 定 占 位</el-button>
            </span>
            </el-dialog>
        </div>
    </div>
</template>
<style type="text/css" scoped>
    .backgroundColor {
        background-color: rgb(254, 101, 101);
    }

    .el-button--primary {
        color: #fff;
        background-color: rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }

    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }

    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }

    .elbutton {
        position: relative;
        left: 50px;
        top: -100px;
    }

    .yuyuem h3 {
        font-weight: normal;
        line-height: 40px;
        color: #476d96;
    }

    .app_first {
        margin-top: 10px;
        padding-bottom: 10px;
        display: flex;
        flex-direction: row;
    }

    .doctor_menu {
        width: 4%;
        margin-left: 28px;
    }

    .app_first table {
        border-color: rgba(255, 255, 255, .5);
        background: #ffffff;
        width: 100%;
        text-align: center;
    }

    .app_first .td_65px {
        height: 44px;
        opacity: .7;
    }

    .right {
        width: 100%;
        padding-bottom: 30px;
        margin-left: 10px;
    }

    .table tr {
        height: 80px;
    }
</style>
<script>
    import "../../assets/css/style1.css"
    import store from '../../store/index';
    import {formatDate} from '../../common/date';

    var myDate = new Date();
    let patientId = '';
    function addZero(v) {  // 补零
        return v < 10 ? '0'+v : v
      }
    function getDateStrArr() {
      let d = new Date();
      let dateStrArr = [];
      for (var i = 0; i < 7; i++) {         // 注入天数
        let d = new Date();
        d.setDate(d.getDate() + i);
        // let dateStr = formatDate(d, 'yyyy-MM-dd')
        let dateStr = d.getFullYear().toString() + '-' + addZero(d.getMonth() + 1) + '-' + addZero(d.getDate());
        dateStrArr.push(dateStr);
      }
      return dateStrArr;
    }
    export default {
        data() {
            return {
                active: false,
                options: [],
                Jname: '',
                startTime: '',
                endTime: '',
                input: '',
                Jdate: Date.now(),
                dialogVis: false,
                tab: '',
                name: '',
                gender: '',
                age: '',
                phone: '',
                reservationId: 0,
                dialogVisible: false,
                seizeVisible:false,
                tabPosition: 'left',
                id: '',
                formInline: {
                    user: '',
                    region: ''
                },
                reserDetail: [],
                items: store.state.weeks_content,
                which_weekDay: myDate.getDay(),
                dayNames: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
                dateArr: getDateStrArr(),  // 今后7天的日期 'yyyy-MM-dd'格式
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                year: myDate.getFullYear(),
                month: myDate.getMonth() + 1,
                day: myDate.getDate(),
                doctor: '',
                emergencyList: [{
                    value: 0,
                    label: '普通诊'
                }, {
                    value: 1,
                    label: '急诊'
                }],
                emergency: 0
            }
        },

        mounted: function () {
            let Jname = {rolename: '患者'};
            this.$axios({
                url: '/api/user/usersByRolename',
                method: 'GET',
                params: Jname
            }).then(res => {
                this.options = res.data.data;
            }).catch(err => {
                this.$message.error('数据获取失败');
            });

            //获取所有医生数据
            let rolename = {rolename: '医生'};
            this.$axios({
                url: '/api/user/usersByRolename',
                method: 'GET',
                params: rolename
            }).then(res => {
                console.log(res);
                this.doctor = res.data.data;
                this.getinfo();
            }).catch(err => {
                this.$message.error('数据获取失败');
            });
        },
        watch: {
            startTime: function () {
                this.endTime = '';
            }
        },
        methods: {
            changeValue(value) {
                patientId = value;
            },
            changeEmeValue(value) {
                this.emergency = value;
            },
            subscribe(value) {                   // 取消预约
                this.$confirm('您确定取消吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(res => {
                    this.$axios({
                        url: "/api/reservation/cancel/" + value,
                        method: "POST"
                    }).then(res => {
                        if(res.data.code == 200){
                            this.dialogVisible = false;
                            this.getinfo();
                        }else{
                            this.dialogVisible = false;
                            this.$alert(res.data.msg)
                        }
                    });
                }).catch(() => {
                    this.dialogVisible = false;
                });
            },
            seize:function(value){
                console.log("reservationId:"+ value)
                this.$axios({
                    url: '/api/reservation/seize',
                    method: 'POST',
                    data: {
                        "id":value,
                        "patientId": patientId,
                    }
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'warning',
                            message: '占位成功，请关注产生的挂号订单，去收银台缴费！'
                        })
                    }
                    else{
                        this.$alert("已有人在移动端抢先预约，占位失败!")
                    }
                    this.getinfo();
                }).catch(err => {
                    this.$message.error('数据获取失败');
                });
                this.seizeVisible = false;
                this.Jname = '';
            },
            getinfo: function () {
                if (this.id == '' && this.doctor.length > 0) {
                    this.id = this.doctor[0].id;
                }
                let startDate = {
                    startDate: formatDate(new Date(), 'yyyy-MM-dd'),
                    endDate: formatDate(Date.now() + 8.64e7 * 6, 'yyyy-MM-dd'),
                    doctorId: this.id
                };
                this.$axios({
                    url: '/api/reservation/pc/getinfo',
                    method: 'GET',
                    params: startDate
                }).then(res => {
                    this.reserDetail = res.data.data;
                }).catch(err => {
                    this.$message.error('数据获取失败');
                });
            },
            sure: function () {
                if (this.Jdate == '' || this.Jname == '' || this.startTime == '' || this.endTime == '') {
                    this.$alert('请填写完整信息')
                    return false;
                }
                this.$axios({
                    url: '/api/reservation/emergency',
                    method: 'POST',
                    data: {
                        "doctorId": this.id,
                        "endTime": this.endTime,
                        "inquiryDate": formatDate(this.Jdate, 'yyyy-MM-dd'),
                        "patientId": patientId,
                        "startTime": this.startTime,
                        "emergency": this.emergency
                    }
                }).then(res => {
                    console.log(res);
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'warning',
                            message: '加诊预约信息生成成功，请关注加诊挂号订单，去收银台缴费！'
                        })
                        this.getinfo();
                    }
                    else {
                      this.$alert(res.data.msg);
                    }
                }).catch(err => {
                    console.log(err)
                });
                this.dialogVis = false;
                this.Jdate = '';
                this.Jname = '';
                this.startTime = '';
                this.endTime = '';
            },
            handleClose(done) {
                done();
            },
            tdclick: function (val, index) {
                if(index != 0 && val !== "--"){
                    if(val.indexOf("**")!== -1){
                        val = val.replace("**..","");
                        this.reservationId = val.split(",")[1]
                        this.seizeVisible = true;
                    }else{
                        this.dialogVisible = true;
                        this.name = val.split(",")[0];
                        this.gender = val.split(",")[2];
                        this.age = val.split(",")[1];
                        this.phone = val.split(",")[3]
                        this.reservationId = val.split(",")[4]
                    }
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// conventionList.vue?0237f499